const Messages = {
    AUTH: {
        USERNAME_EMPTY: "Username cannot be empty.",
        PASSWORD_EMPTY: "Password cannot be empty.",
    },
    ERROR: {
        BAD_REQUEST: "Bad request. Check your input.",
        NETWORK_ERROR: "Network error. Please check your connection.",
        UNAUTHORIZED: "Unauthorized access. Invalid credentials.",
        UNKNOWN_ERROR: "An unexpected error occurred. Please try again.",
        SERVICE_UNAVAILABLE: "Service is currently unavailable. Please try again later.",
        FORBIDDEN: "You do not have permission to access this resource.",
        NOT_FOUND: "The requested resource was not found.",
        TIMEOUT: "The request timed out. Please try again.",
        SERVER_ERROR: "An internal server error occurred.",
        URL_NOT_FOUND: "The requested endpoint was not found.",
        INVALID_RESPONSE_FORMAT: "The server returned an unexpected response. Please contact support.",
        SERVER_DOWN: "Connection to the server was refused.",
        INVALID_INPUT: "The input provided is invalid.",
        NAME_EMPTY:"Name cannot be empty",
        MOBILE_EMPTY:"Mobile number cannot be empty"
    },
    SUCCESS: {
        LOGIN_SUCCESS: "Login successfully.",
        LOGOUT_SUCCESS: "Logout successfully.",
    },
    NETWORK: {
        ONLINE: "You are back online. Connection restored.",
        NO_INTERNET: "You are offline. check your internet connection.",
    }
};

export default Messages;